module.exports = __webpack_public_path__ + "img/puntoa.2124737d.png";